import React from "react"
import { useSelector } from "react-redux";
import { Box, IconButton, Typography } from "@mui/material"
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined"
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined"
import dayjs from "dayjs"
import 'dayjs/locale/es'
import 'dayjs/locale/en'
import CalenderDropDown from "../CalendarDropDown"

//Helpers
import { getMonths } from 'Core/data/Helpers';


export const years = Array.from(
    { length: new Date().getFullYear() - 1989 + 1 },
    (_, i) => (i + 1990).toString()
)

const minYear = parseInt(years[0])
const maxYear = parseInt(years[years.length - 1])

const CustomHeader = ({
    date, changeMonth, changeYear, decreaseMonth, increaseMonth, messages }) => {
    const lang = useSelector(state => state.commonRedux.language);
    const currentYear = date && date.getFullYear()
    const currentMonth = date && date.getMonth()
    const isPrevDisabled = currentYear === minYear && currentMonth === 0
    const isNextDisabled = currentYear === maxYear && currentMonth === 11
    return (
        <Box>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    px: 1,
                    alignItems: "center"
                }}
            >
                <IconButton sx={{ p: "2px" }} onClick={decreaseMonth} disabled={isPrevDisabled}>
                    <ChevronLeftOutlinedIcon />
                </IconButton>
                <Typography variant="body2" fontWeight="bold">
                    {dayjs(date).locale(lang).format("MMMM YYYY")}
                </Typography>
                <IconButton sx={{ p: "2px" }} onClick={increaseMonth} disabled={isNextDisabled}>
                    <ChevronRightOutlinedIcon />
                </IconButton>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-evenly",
                    px: 1,
                    alignItems: "center"
                }}
            >
                <CalenderDropDown
                    values={getMonths(messages)}
                    id="months"
                    nowValue={date && date.getMonth()}
                    isMonth
                    onChange={changeMonth}
                />
                <CalenderDropDown
                    values={years}
                    id="years"
                    nowValue={date && date.getFullYear()}
                    onChange={changeYear}
                />
            </Box>
        </Box>
    )
}

export default CustomHeader
